module.exports = __webpack_public_path__ + "44f7f9a5bc5af9c9ba37d05ca78458c2.svg";